import { convertFromRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";

const customStyleMap = {
  BOLD: { element: "strong" },
  ITALIC: { element: "em" },
  UNDERLINE: { element: "u" },
  "fontsize-8": { style: { fontSize: "8px" } },
  "fontsize-9": { style: { fontSize: "9px" } },
  "fontsize-10": { style: { fontSize: "10px" } },
  "fontsize-11": { style: { fontSize: "11px" } },
  "fontsize-12": { style: { fontSize: "12px" } },
  "fontsize-14": { style: { fontSize: "14px" } },
  "fontsize-16": { style: { fontSize: "16px" } },
  "fontsize-18": { style: { fontSize: "18px" } },
  "fontsize-24": { style: { fontSize: "24px" } },
  "fontsize-30": { style: { fontSize: "30px" } },
  "fontsize-36": { style: { fontSize: "36px" } },
  "fontsize-48": { style: { fontSize: "48px" } },
  "fontsize-60": { style: { fontSize: "60px" } },
  "fontsize-72": { style: { fontSize: "72px" } },
  "fontsize-96": { style: { fontSize: "96px" } },
  SUPERSCRIPT: { element: "sup" },
  SUBSCRIPT: { element: "sub" },
};

// Function to set block styles (e.g., text alignment)
const blockStyleFn = (block) => {
  const alignment = block.getData().get("text-align");
  if (typeof alignment == "string") {
    return {
      style: {
        textAlign: alignment,
      },
    };
  }
  return null;
};

// Reusable function to convert content to HTML
const convertContentToHTML = (rawContent) => {
  try {
    const contentState = convertFromRaw(JSON.parse(rawContent));
    return stateToHTML(contentState, {
      inlineStyles: customStyleMap,
      blockStyleFn: blockStyleFn,
    });
  } catch (error) {
    console.error("Error converting content to HTML:", error);
    return ""; // Return empty string if there is an error
  }
};

export default convertContentToHTML;
